import { IOnInit } from "angular";
import { ChangeJournalLogItem } from "../models";
import {
  ChangeJournalViewItemService,
  vsServiceName as ChangeJournalViewItemServiceName,
} from "../itemObjectDetail";
import { StateService } from "@uirouter/angularjs";

export class ChangeJournalItemComponentController implements IOnInit {
  static $inject = [ChangeJournalViewItemServiceName, "$state"];

  constructor(
    private readonly changeJournalViewItemService: ChangeJournalViewItemService,
    private readonly $state: StateService
  ) {}

  get loadingImageUrl(): string {
    return require("./loading-spinner.gif");
  }

  $onInit(): void {}

  getUrl(logItem: ChangeJournalLogItem): string | undefined {
    if (!logItem.changeJournalObject) {
      return;
    }
    const { sref, params } = this.changeJournalViewItemService
      .getConfigObject(logItem.changeJournalRecord.ObjectName)
      .resolveInfoSref(logItem.changeJournalObject);

    return this.$state.href(sref, params);
  }
}
